module.exports = __webpack_public_path__ + "img/na-labor-assumptions-screen.6c18f116.png";